// @ts-nocheck
import type { Question } from '../types';

export const bicycleInteractionsQuestions: Question[] = [
  {
    id: 'q-bi-1',
    animationId: 'bi-anim-1',
    topic: 'General',
    question: 'You are turning right at an intersection. A cyclist is riding straight ahead on the fietspad that crosses your exit road. Who has priority?',
    options: [
      { id: 'q-bi-1o1', text: 'You do, because you are a motor vehicle' },
      { id: 'q-bi-1o2', text: 'The cyclist does; you must give way before completing the turn' },
      { id: 'q-bi-1o3', text: 'It depends on who arrived at the junction first' },
    ],
    answerId: 'q-bi-1o2',
    explanation: 'A cyclist riding straight on a fietspad has priority over a turning vehicle. You must give way to the cyclist before completing your right turn. (RVV 1990 art. 49)',
    subject: 'Bicycle Interactions',
  },
  {
    id: 'q-bi-2',
    topic: 'General',
    question: 'You want to turn right and a fietspad crosses your path. The cyclist on the fietspad is close. What must you do?',
    options: [
      { id: 'q-bi-2o1', text: 'Sound your horn and continue turning' },
      { id: 'q-bi-2o2', text: 'Stop and wait for the cyclist to pass before completing the turn' },
      { id: 'q-bi-2o3', text: 'Speed up so you complete the turn before the cyclist arrives' },
    ],
    answerId: 'q-bi-2o2',
    explanation: 'Cyclists on a fietspad have right of way over turning traffic. You must stop and wait until the cyclist has safely passed. (RVV 1990 art. 49)',
    subject: 'Bicycle Interactions',
  },
  {
    id: 'q-bi-3',
    topic: 'General',
    question: 'You are overtaking a cyclist on a road without a bicycle lane. What minimum lateral clearance is required under Dutch law?',
    options: [
      { id: 'q-bi-3o1', text: '0.5 metres' },
      { id: 'q-bi-3o2', text: '1.0 metres' },
      { id: 'q-bi-3o3', text: '1.5 metres' },
    ],
    answerId: 'q-bi-3o3',
    explanation: 'RVV 1990 art. 43 requires a minimum lateral clearance of 1.5 metres when overtaking a cyclist. This gives the cyclist space to wobble without danger.',
    subject: 'Bicycle Interactions',
  },
  {
    id: 'q-bi-4',
    animationId: 'bi-anim-4',
    topic: 'General',
    question: 'You are driving in a 30 km/h residential zone and children on bicycles are ahead of you, taking up most of the road. What should you do?',
    options: [
      { id: 'q-bi-4o1', text: 'Overtake them carefully using the oncoming lane' },
      { id: 'q-bi-4o2', text: 'Follow behind at a safe distance without overtaking' },
      { id: 'q-bi-4o3', text: 'Sound your horn so they move to the side' },
    ],
    answerId: 'q-bi-4o2',
    explanation: 'In a 30 km/h zone children on bikes are vulnerable road users. Follow at a safe distance without overtaking; they are unpredictable and the zone speed is low enough to make this safe.',
    subject: 'Bicycle Interactions',
  },
  {
    id: 'q-bi-5',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/bicycle-interactions/bi-5-parking-door.jpg',
    topic: 'General',
    question: 'You have just parked your car next to a fietsstrook. Before opening your door, what must you check?',
    options: [
      { id: 'q-bi-5o1', text: 'Whether the engine is off' },
      { id: 'q-bi-5o2', text: 'Whether a cyclist is approaching in the bicycle lane so you do not cause a dooring collision' },
      { id: 'q-bi-5o3', text: 'Whether the handbrake is on' },
    ],
    answerId: 'q-bi-5o2',
    explanation: 'Opening a car door into an approaching cyclist (dooring) is dangerous and illegal. Always check your mirror and look back before opening your door next to a fietsstrook.',
    subject: 'Bicycle Interactions',
  },
  {
    id: 'q-bi-6',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/bicycle-interactions/bi-6-no-lane.jpg',
    topic: 'General',
    question: 'Why must you leave at least 1.5 metres clearance when overtaking a cyclist?',
    options: [
      { id: 'q-bi-6o1', text: 'To comply with the general speed limit' },
      { id: 'q-bi-6o2', text: 'Because cyclists may wobble or swerve and need space to remain safe' },
      { id: 'q-bi-6o3', text: 'Only because it is legally required on motorways' },
    ],
    answerId: 'q-bi-6o2',
    explanation: 'Cyclists can wobble due to wind, road surface, or obstacles. The 1.5 m clearance ensures they have room to react without being hit. (RVV 1990 art. 43)',
    subject: 'Bicycle Interactions',
  },
  {
    id: 'q-bi-7',
    animationId: null,
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/bicycle-interactions/bi-7-roundabout.jpg',
    topic: 'General',
    question: 'A cyclist signals that they want to turn left. You are driving behind them. What should you do?',
    options: [
      { id: 'q-bi-7o1', text: 'Overtake them immediately to the left before they turn' },
      { id: 'q-bi-7o2', text: 'Slow down and give the cyclist space to complete the manoeuvre safely' },
      { id: 'q-bi-7o3', text: 'Sound your horn to hurry them along' },
    ],
    answerId: 'q-bi-7o2',
    explanation: 'A cyclist indicating a turn has the right to complete that manoeuvre. Slow down and give them sufficient space so they can turn safely.',
    subject: 'Bicycle Interactions',
  },
  {
    id: 'q-bi-8',
    topic: 'General',
    question: 'You want to overtake a cyclist but there is oncoming traffic. What must you do?',
    options: [
      { id: 'q-bi-8o1', text: 'Wait behind the cyclist until the oncoming lane is clear, then overtake with 1.5 m clearance' },
      { id: 'q-bi-8o2', text: 'Overtake anyway; cyclists must move aside' },
      { id: 'q-bi-8o3', text: 'Sound your horn and flash your lights to warn oncoming traffic' },
    ],
    answerId: 'q-bi-8o1',
    explanation: 'You may only overtake when there is enough room in the oncoming lane AND you can maintain 1.5 m from the cyclist. Wait if it is not safe. (RVV 1990 art. 43)',
    subject: 'Bicycle Interactions',
  },
  {
    id: 'q-bi-9',
    animationId: null,
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/bicycle-interactions/bi-9-night-unlit.jpg',
    topic: 'General',
    question: 'On a road with a clearly marked fietsstrook (bicycle lane on the carriageway), may you drive in the bicycle lane?',
    options: [
      { id: 'q-bi-9o1', text: 'Yes, if traffic is heavy' },
      { id: 'q-bi-9o2', text: 'No, motor vehicles must not use the fietsstrook' },
      { id: 'q-bi-9o3', text: 'Only when parking' },
    ],
    answerId: 'q-bi-9o2',
    explanation: 'A fietsstrook is a marked bicycle lane on the carriageway. Motor vehicles must not enter it, even temporarily. Cyclists have exclusive use of it. (RVV 1990 art. 43)',
    subject: 'Bicycle Interactions',
  },
  {
    id: 'q-bi-10',
    topic: 'General',
    question: 'In a 30 km/h zone, a car behind you is waiting to pass children on bikes. Why is it not safe to overtake here?',
    options: [
      { id: 'q-bi-10o1', text: 'Because the children may not be wearing helmets' },
      { id: 'q-bi-10o2', text: 'Because the road may be too narrow and children are unpredictable — following behind is the safe choice' },
      { id: 'q-bi-10o3', text: 'Because the speed limit is 30 and overtaking is always banned at that speed' },
    ],
    answerId: 'q-bi-10o2',
    explanation: 'Children on bikes are unpredictable and may swerve. In a narrow residential road a 1.5 m overtaking clearance may not be possible. Following behind protects them and is the correct approach.',
    subject: 'Bicycle Interactions',
  },
  {
    id: 'q-bi-11',
    animationId: null,
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/bicycle-interactions/bi-11-shared-path.jpg',
    topic: 'General',
    question: 'A cyclist is riding close to the gutter in wet weather. What extra precaution should you take when overtaking?',
    options: [
      { id: 'q-bi-11o1', text: 'Overtake faster to reduce time beside the cyclist' },
      { id: 'q-bi-11o2', text: 'Increase the clearance beyond 1.5 m; wet roads reduce cyclist stability' },
      { id: 'q-bi-11o3', text: 'No extra precaution is needed' },
    ],
    answerId: 'q-bi-11o2',
    explanation: 'Wet roads reduce a cyclist\'s traction and increase the chance of wobbling. Give more than the minimum 1.5 m clearance and reduce your speed. (RVV 1990 art. 43)',
    subject: 'Bicycle Interactions',
  },
  {
    id: 'q-bi-12',
    topic: 'General',
    question: 'At a zebra crossing without bike-priority markings, a cyclist rides across while staying mounted. What is legally correct?',
    options: [
      { id: 'q-bi-12o1', text: 'Cyclists always have zebra-crossing priority, same as pedestrians' },
      { id: 'q-bi-12o2', text: 'Only pedestrians have zebra priority; for cyclists, normal signs/markings determine priority' },
      { id: 'q-bi-12o3', text: 'Cyclists must dismount and wait for a police signal' },
    ],
    answerId: 'q-bi-12o2',
    explanation: 'A zebrapad gives explicit priority to pedestrians. For cyclists who remain mounted, right-of-way depends on road signs/markings (for example haaientanden or dedicated cycle crossing priority). Always avoid conflict and yield when safety requires it.',
    subject: 'Bicycle Interactions',
  },
  {
    id: 'q-bi-13',
    topic: 'General',
    question: 'You are overtaking a cyclist at 50 km/h and approaching a parked car ahead. What must you do?',
    options: [
      { id: 'q-bi-13o1', text: 'Complete the overtake quickly before reaching the parked car' },
      { id: 'q-bi-13o2', text: 'Slow down and wait behind the cyclist until it is safe to overtake with 1.5 m clearance' },
      { id: 'q-bi-13o3', text: 'Sound your horn so the cyclist stops' },
    ],
    answerId: 'q-bi-13o2',
    explanation: 'If completing the overtake would force you too close to the cyclist or the parked car, abort and follow behind. Only overtake when you have sufficient space for the full 1.5 m clearance. (RVV 1990 art. 43)',
    subject: 'Bicycle Interactions',
  },
  {
    id: 'q-bi-14',
    topic: 'General',
    question: 'After overtaking a cyclist, how soon may you move back to the right?',
    options: [
      { id: 'q-bi-14o1', text: 'Immediately after passing the cyclist\'s front wheel' },
      { id: 'q-bi-14o2', text: 'Only once you have passed the cyclist completely and there is a safe gap' },
      { id: 'q-bi-14o3', text: 'You do not need to move back to the right' },
    ],
    answerId: 'q-bi-14o2',
    explanation: 'You must fully pass the cyclist and ensure there is a safe distance before returning to the right lane. Cutting back too early can clip the cyclist. (RVV 1990 art. 43)',
    subject: 'Bicycle Interactions',
  },
];
